var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "highlight-current-row": "",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              index: _vm.tableIndex,
              label: _vm.$t("trainingRecords.table.systemPk"),
              width: "60",
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "trainingCourse",
              label: _vm.$t("trainingRecords.table.trainingCourse"),
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "trainingDate",
              label: _vm.$t("trainingRecords.table.trainingDate"),
              width: "120",
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "trainingLocation",
              label: _vm.$t("trainingRecords.table.trainingLocation"),
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "trainer",
              label: _vm.$t("trainingRecords.table.trainer"),
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "trainingChannel",
              label: _vm.$t("trainingRecords.table.trainingChannel"),
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "gyTrainerComments",
              label: _vm.$t("trainingRecords.table.gyTrainerComments"),
              "min-width": "140",
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "trainingAchievement",
              label: _vm.$t("trainingRecords.table.trainingAchievement"),
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nextTrainingPlan",
              label: _vm.$t("trainingRecords.table.nextTrainingPlan"),
              align: "left",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }